import React from "react";
import { message, Form, Switch, Radio } from "antd";
import styled from "styled-components";
import {
  DeleteOutlined,
  PlusOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
} from "@ant-design/icons";

import colors from "constants/palette";
import Button from "components/buttons/Button";
import Input from "components/inputs/Input";

export default function ColorPicker({ form, initialValue }) {
  const [isActive, setIsActive] = React.useState(
    initialValue && typeof initialValue === "object"
      ? initialValue?.isActive
      : false
  );
  const [color, setColor] = React.useState(null);
  const [title, setTitle] = React.useState(null);
  const [showType, setShowType] = React.useState(
    initialValue && typeof initialValue === "object"
      ? initialValue?.showType
      : "b"
  );
  const [refresh, setRefresh] = React.useState(false);
  const [list, setList] = React.useState(
    initialValue && typeof initialValue === "object" ? initialValue?.list : []
  );
  console.log("Color, ", list);

  const reload = () => setRefresh((e) => !e);

  const handleTitleChange = (e) => {
    setTitle(e.target.value);
  };

  const handleColorChange = (e) => {
    setColor(e.target.value);
  };
  const handleAdd = () => {
    if (!color && !title) {
      message.error("لطفا یک رنگ یا عنوان وارد کنید!");
      return false;
    }
    if (color && list.findIndex((e) => e.color === color) > -1) {
      message.error("رنگ وارد شده تکراری است!");
      return false;
    }
    if (title && list.findIndex((e) => e.title === title) > -1) {
      message.error("عنوان وارد شده تکراری است!");
      return false;
    }
    setList((e) => [...e, { color, title, isActive: true }]);
    setTitle(undefined);
    setColor(null);
    reload();
  };
  const handleEdit = (type, value, key) => {
    console.log("Color, ", value, key);
    if (value && list.findIndex((e) => e[type] === value) > -1) {
      message.error("مقدار وارد شده تکراری است!");
      return false;
    }

    setList((e) => {
      let x = [...e];
      x[key] = {
        ...x[key],
        [type]: value,
      };
      return x;
    });
    reload();
    return;
  };
  const handleDelete = (key) => {
    setList((e) => {
      let newList = [...e];
      newList.splice(key, 1);
      return newList;
    });
  };
  const handleDeactive = (key) => {
    setList((e) => {
      let newList = [...e];
      newList[key] = { ...newList[key], isActive: !newList[key].isActive };
      return newList;
    });
  };

  React.useEffect(() => {
    form.setFieldsValue({
      color: {
        isActive,
        list,
        showType,
      },
    });
    if (showType === "t" && list.filter((i) => !i?.title).length) {
      message.error("لطفا برای همه رنگ ها عنوان را وارد کنید!!!");
    }
  }, [list, isActive, showType]);
  return (
    <Form.Item name="color">
      <Switch onChange={setIsActive} checked={isActive} />
      <br />
      <br />
      {isActive ? (
        <Container key="color">
          <Radio.Group
            value={showType}
            buttonStyle="solid"
            style={{ margin: "6px 0" }}
            onChange={(e) => setShowType(e.target.value)}
          >
            <Radio.Button value={"b"} key={1}>
              هردو
            </Radio.Button>
            <Radio.Button value={"c"} key={2}>
              رنگ
            </Radio.Button>
            <Radio.Button value={"t"} key={3}>
              عنوان
            </Radio.Button>
          </Radio.Group>
          {list?.length
            ? list?.map((item, key) => (
                <div
                  className="item"
                  style={{ opacity: item.isActive ? 1 : 0.4 }}
                  key={key}
                >
                  <input
                    data-index={key}
                    defaultValue={item.title}
                    placeholder={!item.title ? "بدون عنوان" : null}
                    onBlur={(e) => handleEdit("title", e.target.value, key)}
                  ></input>
                  <input
                    type="color"
                    key={key}
                    value={item.color}
                    defaultValue={"transparent"}
                    onChange={(e) => handleEdit("color", e.target.value, key)}
                  />
                  <span dir="ltr" style={{ marginRight: 6 }}>
                    {item.color ?? "(بدون مقدار)"}
                  </span>{" "}
                  <DeleteOutlined
                    className="delete"
                    onClick={() => handleDelete(key)}
                  />
                  {item.isActive ? (
                    <EyeInvisibleOutlined onClick={() => handleDeactive(key)} />
                  ) : (
                    <EyeOutlined onClick={() => handleDeactive(key)} />
                  )}
                </div>
              ))
            : null}

          <h3 style={{ marginTop: 20 }}>رنگ جدید :</h3>
          <InputContainer>
            <Input
              placeholder="عنوان"
              onChange={handleTitleChange}
              value={title}
            />
            <Input
              placeholder="وزن"
              onChange={handleColorChange}
              type="color"
            />

            <Button
              type="button"
              size="middle"
              onClick={handleAdd}
              value={color}
            >
              <PlusOutlined />
              اضافه کردن{" "}
            </Button>
          </InputContainer>
        </Container>
      ) : null}
    </Form.Item>
  );
}

const Container = styled.div`
  text-align: start;
  align-items: center;

  & .item {
    padding: 7px;
    border-radius: 4px;
    margin-bottom: 8px;
    border: 1px dashed #d5d5d5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > input {
      height: 36px;
      background-color: none;
      border: none;
      cursor: pointer;
    }

    & .delete {
      color: red;
      margin-right: auto;
      font-size: 18px;
      cursor: pointer;
      padding: 2px 8px;
      width: 36px;
    }
  }
`;
const InputContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  & > div {
    height: 50px;
    margin-top: 0;
    width: 49%;
    input {
      height: 40px !important;
      width: 100%;
      min-width: 70px;
      padding: 0 4px;
    }
  }
  button {
    width: 100%;
    height: 38px;
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  & .ant-radio-button-wrapper-checked span {
    background-color: ${colors.primary};
  }
`;
